import axios from 'axios'

import { DNS_DASH_API } from '../../config/envVars'
import getHeaders from '../helpers/headers'
import getError from '../helpers/getError'

/**
 * Get info for current plan
 * @returns {Promise<object>}
 */
const getCurrent = async () => {
  try {
    const { data } = await axios({
      url: `${DNS_DASH_API}/plans/current`,
      method: 'get',
      headers: getHeaders(true)
    })

    return data
  } catch(error) {
    throw getError(error)
  }
}

/**
 * Get available plans to choose a change
 * @returns {Promise<object>}
 */
const getAvailable = async () => {
  const { data } = await axios({
    url: `${DNS_DASH_API}/plans/available`,
    method: 'get',
    headers: getHeaders(true)
  })

  return data
}

/**
 * Get available plans to choose a change
 * @param {object} payload
 * @param {string} payload.identifier
 *
 * @returns {Promise<{company: object}>}
 */
const changePlan = async (payload) => {
  try {
    const { data } = await axios({
      url: `${DNS_DASH_API}/plans/change`,
      method: 'post',
      headers: getHeaders(true),
      data: payload
    })

    return data
  } catch(error) {
    throw getError(error)
  }
}

export default {
  getCurrent,
  getAvailable,
  changePlan
}
